import { z } from 'zod'
import { requiredString } from '../primitives'
import { PlaceSchema } from './place'

// Forma REAL (shared/schemas/address.ts): Place + { address, zone? }
export const AddressSchema = PlaceSchema.extend({
  address: requiredString(),
  zone: z.number().int().optional()
})

export type Address = z.infer<typeof AddressSchema>
